const SocialMedia = ({ player }) => {
  return (
    <div>
      <h3>Social Media</h3>
      <ul>
        {/* {player.socialMedia.map((sm) => (
            <li key={sm.id}>
              {sm.platform}: <a href={sm.profileLink}>{sm.profileLink}</a>
            </li>
          ))} */}
      </ul>
    </div>
  );
};

export default SocialMedia;
